// Константы селекторов
const SELECTORS = {
  FIRST_LEVEL_ITEMS: ".footer__menu-item--first-level .footer__menu-item-title",
  MENU_ITEM_TITLE_ACTIVE: "footer__menu-item-title--active",
  MENU_SUBLIST: "footer__menu-sublist",
};

export default class FooterDropdown {
  constructor() {
    // Аккордеон работает только на мобильной ширине (см. mixin mobile в SCSS)
    this.mobileQuery = window.matchMedia("(max-width: 767px)");

    this.firstLevelItems = document.querySelectorAll(
      SELECTORS.FIRST_LEVEL_ITEMS,
    );
    this.setListeners();
    this.syncAccessibility();
  }

  setListeners() {
    this.firstLevelItems.forEach((item) => {
      item.addEventListener("click", () => this.toggle(item));
      item.addEventListener("keydown", (event) =>
        this.keydownHandler(event, item),
      );
    });

    // Ширина может измениться (поворот экрана, масштаб страницы)
    this.mobileQuery.addEventListener("change", () =>
      this.syncAccessibility(),
    );
  }

  hasSublist(item) {
    return item.nextElementSibling?.classList.contains(SELECTORS.MENU_SUBLIST);
  }

  /**
   * На мобильной ширине заголовок раздела ведёт себя как кнопка,
   * на широких экранах это обычный заголовок без интерактивности.
   */
  syncAccessibility() {
    this.firstLevelItems.forEach((item) => {
      if (this.mobileQuery.matches && this.hasSublist(item)) {
        item.setAttribute("role", "button");
        item.setAttribute("tabindex", "0");
        item.setAttribute(
          "aria-expanded",
          String(item.classList.contains(SELECTORS.MENU_ITEM_TITLE_ACTIVE)),
        );
      } else {
        item.removeAttribute("role");
        item.removeAttribute("tabindex");
        item.removeAttribute("aria-expanded");
      }
    });
  }

  toggle(item) {
    if (!this.mobileQuery.matches) {
      return;
    }

    const isActive = item.classList.toggle(SELECTORS.MENU_ITEM_TITLE_ACTIVE);
    if (item.hasAttribute("aria-expanded")) {
      item.setAttribute("aria-expanded", String(isActive));
    }
  }

  keydownHandler(event, item) {
    if (event.key !== "Enter" && event.key !== " ") {
      return;
    }

    if (this.mobileQuery.matches && this.hasSublist(item)) {
      event.preventDefault();
      this.toggle(item);
    }
  }
}
